import React, { Fragment } from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { Redirect } from "react-router-dom";
import NavBar from "~/components/mobile/atoms/NavBar";
import Button from "~/components/common/atoms/Button";
// import NewArticle from "~/components/mobile/organisms/NewArticle";
import UtilitiesTwoMobile from "~/components/mobile/organisms/UtilitiesTwo";
import MenuBarBottom from "~/components/mobile/molecules/MenuBar";
import Welcome from "~/components/mobile/organisms/Welcome";
import BannerHomeMobile from "~/components/mobile/molecules/BannerHome/mobile";
import ListServiceMobile from "~/components/mobile/molecules/ListService";
import Footer from "~/components/mobile/organisms/Footer";
import styles from "./style.module.scss";
class HomePageMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToLoginPage: false,
      modal: true,
      menuBarBottomHeight: 0
    };
  }

  checkIsAuthenticated = isAuthenticated => {
    if (!this.state.redirectToLoginPage) {
      this.setState({
        redirectToLoginPage: true
      });
    }
  };

  componentDidMount() {
    if (this.props.menuBarBottomRef.current) {
      this.setState({
        menuBarBottomHeight: this.props.menuBarBottomRef.current.clientHeight
      });
    }
  }

  render() {
    const { redirectToLoginPage } = this.state;
    if (redirectToLoginPage) {
      return <Redirect push to="/login" />;
    }
    return (
      <Fragment>
        <div className={styles.main_content}>
          <NavBar
            hideLeft
            rightContent={[
              <Button
                column="column"
                color=""
                menu="menu"
                icon={<i className="fal fa-bars" />}
                key={1}
              >
                Menu
              </Button>
            ]}
          />
          <Welcome />

          <div className={styles.service_mobile}>
            <MDBContainer>
              <MDBRow>
                <MDBCol size="12">
                  <BannerHomeMobile />
                  <ListServiceMobile
                    checkIsAuthenticated={this.checkIsAuthenticated}
                  />
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </div>
          <UtilitiesTwoMobile />

          <Footer />
          <div
            style={{
              height: this.state.menuBarBottomHeight
            }}
          />
          <MenuBarBottom
            menuBarBottomRef={this.props.menuBarBottomRef}
            currentLocation={this.props.location.pathname}
          />
        </div>
      </Fragment>
    );
  }
}
export default HomePageMobile;
